import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { type KeyPhraseNodeType } from './api/useAutohighlightSupplier';
import { getHighlightCategories } from './common/get-highlight-categories';

export const onShownAutoDefinitionHighlights = ({
	product,
	contentId,
	keyPhrases,
	fieldType,
}: {
	product: string;
	contentId: string;
	keyPhrases: KeyPhraseNodeType[];
	fieldType?: string;
}): AnalyticsEventPayload => ({
	action: 'shown',
	actionSubject: 'aiDefinitionsAutohighlights',
	source: 'viewPageScreen',
	eventType: 'track',
	attributes: {
		product,
		contentId,
		numHighlights: keyPhrases.length,
		categories: getHighlightCategories(keyPhrases),
		beAcronymsEnabled: true,
		fieldType,
	},
});
